/* eslint-disable max-len */
import { usersList } from "./apiSlice";

export const dashboardTemplateList=usersList.injectEndpoints({
    tagTypes:['Alerts','AssociatedProviderAlert','ProviderAlert','AssociatedProviderToPatient'],
    endpoints:(builder)=>({
        getAlertList: builder.query({
            query: (queryParamsPassed) => `patients/list-historical-readings?${queryParamsPassed?.searchparams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                
                'Alerts',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'Alerts', id:_id}))
            ]:[]
            
        }),
        getProviderAssociatedToPatientListModal: builder.query({
            query: (searchParams) => `patients/list-linked-providers?patient_id=${searchParams}&action=view`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderToPatient',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'AssociatedProviderToPatient', id:patient_id}))
            ]:[],
        }),
        // send provider alert api
        sendProviderAlert:builder.mutation({
            query:org=>({
                url:`/patients/send-alert`,
                method:'POST',
                body:org
            }),
            providesTags:(result,error,arg)=>error===undefined?[
                'ProviderAlert',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'ProviderAlert', id:patient_id}))
            ]:[],
            invalidatesTags:['AssociatedProviderAlert']
        }),
        // providerAlertlist
        getProviderAlert: builder.query({
            query: (searchParams) => `patients/list-provider-alert?patient_id=${searchParams}`,
            providesTags:(result=[],error,arg)=>error===undefined?[
                'AssociatedProviderAlert',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({patient_id})=>({type:'AssociatedProviderToPatient', id:patient_id}))
            ]:[],
            invalidatesTags: ['ProviderAlert']
        }),

        

    }),
    overrideExisting: false
})


export const {
    useGetAlertListQuery,
    useGetProviderAssociatedToPatientListModalQuery,
    useSendProviderAlertMutation,
    useGetProviderAlertQuery,

}=dashboardTemplateList